export default "__VITE_ASSET__C_5va_NX__"